import React from 'react';
import moment from "moment";
import {green500, grey500, white} from "material-ui/styles/colors";
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import eventService from "core/event/eventService";
import MdEntity from "core/metamodel/mdEntity";
import {action} from "mobx";
import origin = __MaterialUI.propTypes.origin;
import {Party, PARTYCATEGORY} from "party/partyDomain";
import Avatar from "material-ui/Avatar";
import {observer} from "mobx-react";
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import {AxiosError} from "axios";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import {WithActive} from "core/event/eventDomain";

const __anchorOrigin: origin = {horizontal: 'left', vertical: 'top'};
const iconButton__style = {width: 32, height: 32, padding: "0 8px 0 0"};


interface PartyActiveCompProps {
  partyObject: Party;
  entity: MdEntity,
  partyCategoryEntity: MdEntity
}

@observer
export class PartyActiveComp extends React.Component<PartyActiveCompProps, undefined> {

  private forceCloseConfirmationRef: ConfirmationDialog;

  @action onClose = () => {
    let {partyObject, entity} = this.props;
    console.log('onClose');
    ((partyObject.$new) ? Promise.resolve({
      active: false,
      closeDate: moment().startOf("day").toDate()
    }) : eventService.closeObject(entity, partyObject.partyId))
      .then(action("onClose-handler", (data: WithActive) => {
        partyObject.active = data.active;
        partyObject.closeDate = data.closeDate;
      }))
      .catch((error: AxiosError) => {
        let response = error.response;
        if (response && response.status === 400) {
          return new Promise((resolve, reject) => {
            console.log(error.getMessages());
            return this.forceCloseConfirmationRef.open(resolve, reject, error.getMessagesString());
          }).then(() => {
            return eventService.closeObject(entity, partyObject.partyId, true);
          }).then((data: WithActive) => {
            partyObject.active = data.active;
            partyObject.closeDate = data.closeDate;
          }).catch((e) => {
          });
        }
        partyObject.$errors = error.getMessages();
      });
  };


  @action onOpen = () => {
    let {partyObject, entity} = this.props;
    console.log('onOpen');
    ((partyObject.$new) ? Promise.resolve({active: true}) : eventService.openObject(entity, partyObject.partyId))
      .then(action("onOpen-handler", (data: WithActive) => {
        partyObject.active = data.active;
        partyObject.closeDate = data.closeDate;
      }));
  };

  @action onPE = () => {
    let {partyObject} = this.props;
    partyObject.partyCategory = PARTYCATEGORY.PE;
    partyObject.$dirty = true;
  };
  @action onCO = () => {
    let {partyObject} = this.props;
    partyObject.partyCategory = PARTYCATEGORY.CO;
    partyObject.$dirty = true;
  };
  @action onEN = () => {
    let {partyObject} = this.props;
    partyObject.partyCategory = PARTYCATEGORY.EN;
    partyObject.$dirty = true;
  };


  forceCloseConfirmationRefHandler = comp => this.forceCloseConfirmationRef = comp;

  render() {
    const {partyObject, partyCategoryEntity, ...other} = this.props;


    let iconButtonElement = (
      <IconButton style={iconButton__style} >
        <Avatar
          color={white}
          backgroundColor={partyObject.active ? green500 : grey500}
          size={20}>{partyObject.partyCategory.substr(0, 1)}</Avatar>
      </IconButton>
    );

    const menuItems = [];
    switch (partyObject.partyCategory) {
      case PARTYCATEGORY.CO:
        menuItems.push(<MenuItem primaryText={partyCategoryEntity.getLovItemLabel(PARTYCATEGORY.PE)} onClick={this.onPE}/>);
        menuItems.push(<MenuItem primaryText={partyCategoryEntity.getLovItemLabel(PARTYCATEGORY.EN)} onClick={this.onEN}/>);
        break;
      case PARTYCATEGORY.PE:
        menuItems.push(<MenuItem primaryText={partyCategoryEntity.getLovItemLabel(PARTYCATEGORY.CO)} onClick={this.onCO}/>);
        menuItems.push(<MenuItem primaryText={partyCategoryEntity.getLovItemLabel(PARTYCATEGORY.EN)} onClick={this.onEN}/>);
        break;
      case PARTYCATEGORY.EN:
        menuItems.push(<MenuItem primaryText={partyCategoryEntity.getLovItemLabel(PARTYCATEGORY.PE)} onClick={this.onPE}/>);
        menuItems.push(<MenuItem primaryText={partyCategoryEntity.getLovItemLabel(PARTYCATEGORY.CO)} onClick={this.onCO}/>);
        break;

    }


    return (
      <div>
        <ConfirmationDialog ref={this.forceCloseConfirmationRefHandler} cancelButtonText="Cancel" okButtonText="Ok" />
        <IconMenu iconButtonElement={iconButtonElement} anchorOrigin={__anchorOrigin} targetOrigin={__anchorOrigin}>
          { (partyObject.active) ? <MenuItem primaryText="Close" onClick={this.onClose} /> : <MenuItem primaryText="Open" onClick={this.onOpen} /> }
          <MenuItem
            primaryText="Change Category"
            rightIcon={<ArrowDropRight />}
            menuItems={menuItems}
          />
        </IconMenu>
      </div>
    );


  }

}



// WEBPACK FOOTER //
// ./src/party/component/partyActiveComp.tsx